import { z } from 'zod';
import { CommonFilter_Config_S, CommonFilter_RequestParams_S, CommonFilter_State_S } from './commonFilter.schema';

export const KeyWordFilterKey_S = z.object({
    key: z.number().or(z.string()),
    doc_count: z.number(),
});

export const KeyWordsFilterValues_S = z.object({
    keywords: z.array(KeyWordFilterKey_S),
});

/**
 * KEYWORD FILTER CONFIGURATION
 * */
export const KeyWordFilter_Config_S = CommonFilter_Config_S.extend({
    type: z.literal('keyword'),
    values: KeyWordsFilterValues_S,
});

/**
 * KEYWORD FILTER STATE
 * */
export const KeyWordFilterKey_State_S = KeyWordFilterKey_S.extend({
    isDisabled: z.boolean(),
});

export const KeyWordFilter_State_S = KeyWordFilter_Config_S.merge(CommonFilter_State_S)
    .omit({ values: true })
    .extend({
        values: z.object({
            keywords: z.array(KeyWordFilterKey_State_S),
        }),
    });

/**
 * KEYWORD FILTER CONTROLS STATE
 */
export const KeyWordFilterKey_ControlsState_S = KeyWordFilterKey_S.pick({ key: true }).extend({
    isChecked: z.boolean(),
});

export const KeyWordsFilterValues_ControlsState_S = z.object({
    keywords: z.array(KeyWordFilterKey_ControlsState_S),
});

export const KeyWordFilter_ControlsState_S = KeyWordFilter_Config_S.pick({ identifier: true, type: true }).extend({
    applyFilter: z.boolean(),
    values: KeyWordsFilterValues_ControlsState_S,
});

/**
 * KEYWORD FILTER REQUEST PARAMS
 */
export const KeyWordFilter_RequestParams_S = CommonFilter_RequestParams_S.extend({
    selectedValues: z.array(z.string()),
});

/**
 * KEYWORD FILTER SNAPSHOT
 * */
export const KeyWordFilter_Snapshot_S = CommonFilter_Config_S.pick({ identifier: true }).extend({
    values: z.array(z.number().or(z.string())),
});

/**
 * KEYWORD FILTER STATE AGGREGATION RESPONSE
 * */
export const KeyWordFilterAggregation_S = z.array(KeyWordFilterKey_S);
